import Backbone from 'backbone'
import _ from 'lodash'
import template from './edit-reports-component-dialog.hbs'

var EditReportsComponentDialog = Backbone.View.extend({

	tagName: 'form',

	events: {
		'submit': 'submit'
	},

	initialize: function(options) {
		if (!options || !options.view) {
			throw new Error('Must define view for dialog')
		}
		this.options = options
	},

	render: function() {
		this.view = new this.options.view(this.options)
		this.$el.html(template(this.options))
			.find('.dialog-body-content')
			.append(this.view.el)
		this.view.render()
		this.view.delegateEvents()
		return this
	},

	submit: function(e) {
		e.preventDefault()
		this.trigger('done', this.model)
	},

	remove: function() {
		Backbone.View.prototype.render.apply(this, this.arguments)
		_.invokeMap([this.view], 'remove')
	}

})

export default EditReportsComponentDialog

EditReportsComponentDialog.__filename__ = 'reports/common/edit-reports-component-dialog.js'
